import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  const isActive = (path: string) => location.pathname === path;

  const displayName = user
    ? [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email || 'Account'
    : '';

  return (
    <header className="app-header">
      <div className="header-inner container">
        <Link to="/" className="header-logo">
          <img src="/logo.png" alt="KeeDocs" className="logo-icon" />
          <span className="logo-text">KeeDocs</span>
        </Link>

        {/* Desktop Nav */}
        <nav className="header-nav">
          {user ? (
            <>
              <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}>
                Dashboard
              </Link>
              <Link to="/upload" className={`nav-link ${isActive('/upload') ? 'active' : ''}`}>
                Upload
              </Link>
            </>
          ) : (
            <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
              Quick Share
            </Link>
          )}
          <Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active' : ''}`}>
            Contact
          </Link>
        </nav>

        <div className="header-actions">
          {user ? (
            <>
              <Link to="/profile" className="user-chip">
                <span className="user-avatar">{displayName.charAt(0).toUpperCase()}</span>
              </Link>
              <button onClick={handleLogout} className="btn btn-secondary btn-sm">
                Sign Out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-secondary btn-sm">Sign In</Link>
              <Link to="/register" className="btn btn-primary btn-sm">Get Started</Link>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          className="hamburger"
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="mobile-menu">
          {user ? (
            <>
              <Link to="/dashboard" className="mobile-link" onClick={() => setMenuOpen(false)}>Dashboard</Link>
              <Link to="/upload" className="mobile-link" onClick={() => setMenuOpen(false)}>Upload</Link>
              <Link to="/contact" className="mobile-link" onClick={() => setMenuOpen(false)}>Contact</Link>
              <Link to="/profile" className="mobile-link" onClick={() => setMenuOpen(false)}>Profile</Link>
              <button onClick={handleLogout} className="mobile-link mobile-link-danger">Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/" className="mobile-link" onClick={() => setMenuOpen(false)}>Quick Share</Link>
              <Link to="/contact" className="mobile-link" onClick={() => setMenuOpen(false)}>Contact</Link>
              <Link to="/login" className="mobile-link" onClick={() => setMenuOpen(false)}>Sign In</Link>
              <Link to="/register" className="mobile-link" onClick={() => setMenuOpen(false)}>Get Started</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;
